import type {ForestMassSpecies} from '@/domain/entities/ForestMassSpecies';
import type {ForestMassSpeciesDto} from './ForestMassSpeciesDto';

export const toDomain = (dto: ForestMassSpeciesDto): ForestMassSpecies => ({
  ...dto,
});
